






import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { Config } from "@/shared/config";
import _ from "lodash";
import { usePartnerContentStore } from "@/shared/store/partnerContent";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";

@Component
export default class PartnerFooter extends Vue {
  @Prop({ default: "text-center" }) textClass: string;

  partnerContentStore = usePartnerContentStore();
  portalCustomizationStore = usePortalCustomizationStore();
  footerContent = "";

  get isLoadingFooterContent () {
    return this.partnerContentStore.isLoadingPartnerFooterContent;
  }

  mounted () {
    let partnerId = (this.$route.query.partner || this.partnerContentStore.partnerId);

    // Config.Mobile.PartnerId is set from the bitrise build for each partner-specific app
    if (Config && Config.Mobile && Config.Mobile.PartnerId && Number(Config.Mobile.PartnerId) > 0) {
      partnerId = Config.Mobile.PartnerId;
    }

    const parsedPartnerId = _.toSafeInteger(partnerId);

    if (parsedPartnerId) {
      this.partnerContentStore.getPartnerFooterContent(parsedPartnerId);
    }

    this.onFooterContentLoaded();
  }

  @Watch("$route.query.partner")
  refreshPartnerFooter () {
    const partnerId = (this.$route.query.partner || this.partnerContentStore.partnerId);
    const parsedPartnerId = _.toSafeInteger(partnerId);

    if (parsedPartnerId) {
      this.partnerContentStore.getPartnerFooterContent(parsedPartnerId);
    }
  }

  @Watch("partnerContentStore.isLoadingFooterContent")
  onFooterContentLoaded () {
    if (this.partnerContentStore.isLoadedPartnerFooterContent) {
      this.footerContent = this.partnerContentStore.partnerFooterContent;
    }
  }
}
